module.exports = {"name":"softBlock","meta":{"description":"Add soft block to public boards if user is not logged in","link":"https://trello.com/c/x7TZRCGq/245-epic-soft-block"},"audiences":["englishMembers"],"experimentAllocation":{"allMembers":1},"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/softBlock.json
// module id = CNOs
// module chunks = 13